var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ThePageSkeleton',{attrs:{"scroll-y":"","content-flex":""}},[_c('div',{staticClass:"page-no-multi-company-support__content"},[_c('LogoAuthPages'),_c('p',[_vm._v(_vm._s(_vm.$t('Dieses Feature unterstützt derzeit nur einen gewählten Betrieb.')))]),_c('CompanySwitch',{attrs:{"block":"","right":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }